import { KIND_LABEL, type ResultKind } from "./resultKind";

/**
 * The 26px band down the left of every result row, naming its kind (日本-498).
 *
 * **Every row carries one, dictionary rows included** (Alex, 27 Aug 2026). Marking only the new
 * kinds would make the list two shapes — plain rows and marked rows — and a name row would then
 * cost a third. One shape, and the kind reads at scanning speed rather than after you stop.
 *
 * **Achromatic, and that is forced rather than a preference.** `tokens.css` has one accent with one
 * meaning — red marks what wants you — and licenses exactly two colour exceptions (Anki's flags and
 * the heatmap). The retired frame `5g` drew a violet GRAMMAR badge; that was the light theme, and
 * reviving it here would be a third exception. So the kind is told by position and by the word.
 *
 * Vertical because the rail already sets that idiom, which is what makes this read as part of this
 * app rather than as a new device.
 */
export function KindGutter({ kind }: { kind: ResultKind }) {
  return (
    <div
      aria-hidden
      data-check="result.kind"
      data-kind={kind}
      className="flex w-[26px] shrink-0 items-center justify-center border-r border-line bg-raised"
    >
      <span
        className="font-jp text-meta font-semibold tracking-[.08em] text-ink-3"
        style={{ writingMode: "vertical-rl" }}
      >
        {KIND_LABEL[kind]}
      </span>
    </div>
  );
}
